var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadeauBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 811,
    viewBox: "0 0 375 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193 -109V136H214.5L265.5 -109H193Z",
    fill: "url(#paint0_linear_6641_17043)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M150.172 -111.891L173.46 132L152.057 134.044L78.0001 -104.999L150.172 -111.891Z",
    fill: "url(#paint1_linear_6641_17043)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M237 758.5L195 211H216.5L346.5 784L237 758.5Z",
    fill: "url(#paint2_linear_6641_17043)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.499 765L178.755 214.66L157.338 212.77L6.49903 802.5L134.499 765Z",
    fill: "url(#paint3_linear_6641_17043)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M322.268 -97L238 133.052L258.188 140.447L390.344 -72.0637L322.268 -97Z",
    fill: "url(#paint4_linear_6641_17043)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.1855 -97L129.453 133.052L109.265 140.447L-22.8911 -72.0637L45.1855 -97Z",
    fill: "url(#paint5_linear_6641_17043)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M447.506 -19L264.999 144.452L279.343 160.467L495.874 35.007L447.506 -19Z",
    fill: "url(#paint6_linear_6641_17043)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-80.0527 -19L102.454 144.452L88.1099 160.467L-128.421 35.007L-80.0527 -19Z",
    fill: "url(#paint7_linear_6641_17043)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M527.406 147L283.001 164.055L284.497 185.503L532.453 219.324L527.406 147Z",
    fill: "url(#paint8_linear_6641_17043)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-159.953 147L84.4525 164.055L82.9559 185.503L-165 219.324L-159.953 147Z",
    fill: "url(#paint9_linear_6641_17043)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M497.389 297.232L276.14 192L266.905 211.416L466.248 362.704L497.389 297.232Z",
    fill: "url(#paint10_linear_6641_17043)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-129.936 297.232L91.3134 192L100.548 211.416L-98.7953 362.704L-129.936 297.232Z",
    fill: "url(#paint11_linear_6641_17043)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M631.5 736L252.787 203L234.167 213.75L449 761.25L478 761.25L631.5 736Z",
    fill: "url(#paint12_linear_6641_17043)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-9.00009 413.31L117.711 203.622L136.112 214.741L-72.0004 750.501L-9.00009 413.31Z",
    fill: "url(#paint13_linear_6641_17043)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6641_17043",
    x1: 229,
    y1: -53,
    x2: 203.5,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6641_17043",
    x1: 119.658,
    y1: -52.7223,
    x2: 163.007,
    y2: 132.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6641_17043",
    x1: 231,
    y1: 400,
    x2: 205.5,
    y2: 211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6641_17043",
    x1: 126.28,
    y1: 399.764,
    x2: 168.295,
    y2: 213.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6641_17043",
    x1: 336.81,
    y1: -32.0345,
    x2: 247.859,
    y2: 136.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6641_17043",
    x1: 30.6431,
    y1: -32.0345,
    x2: 119.594,
    y2: 136.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6641_17043",
    x1: 429.807,
    y1: 45.1776,
    x2: 272.005,
    y2: 152.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6641_17043",
    x1: -62.3544,
    y1: 45.1776,
    x2: 95.4486,
    y2: 152.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6641_17043",
    x1: 474.048,
    y1: 186.811,
    x2: 283.732,
    y2: 174.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6641_17043",
    x1: -106.595,
    y1: 186.811,
    x2: 83.7216,
    y2: 174.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6641_17043",
    x1: 431.355,
    y1: 305.689,
    x2: 271.63,
    y2: 201.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6641_17043",
    x1: -63.9016,
    y1: 305.689,
    x2: 95.8234,
    y2: 201.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6641_17043",
    x1: 316.11,
    y1: 384.679,
    x2: 243.694,
    y2: 208.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6641_17043",
    x1: 50.7719,
    y1: 384,
    x2: 126.695,
    y2: 209.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadeauBackground);
export default __webpack_public_path__ + "static/media/cadeau-background.ea0f72a40d67cac00f19f8ab672f66ca.svg";
export { ForwardRef as ReactComponent };